import DataTableCell_default from "./DataTableCell.vue.js";
import { createBlock, createElementVNode, createTextVNode, defineComponent, openBlock, renderSlot, toDisplayString, withCtx } from "vue";
//#region src/v2/components/data-table/DataTableText.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = { class: "flex-1 px-2 py-1.5 whitespace-nowrap" };
var DataTableText_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "DataTableText",
	props: { text: {} },
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createBlock(DataTableCell_default, { class: "relative flex" }, {
				default: withCtx(() => [createElementVNode("span", _hoisted_1, [renderSlot(_ctx.$slots, "default", {}, () => [createTextVNode(toDisplayString(__props.text), 1)])])]),
				_: 3
			});
		};
	}
});
//#endregion
export { DataTableText_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=DataTableText.vue_vue_type_script_setup_true_lang.js.map